import { cva, type VariantProps } from 'class-variance-authority';
import { ReactNode } from 'react';

import { cn } from '../../../libs/utils';

const SUB_TITLE_FONT = {
  large: 'body-medium-medium text-neutral-foreground-main',
  medium: 'body-small-medium text-neutral-foreground-low',
  small: 'caption-medium-regular text-neutral-foreground-low'
};

const DESCRIPTION_FONT = {
  large: 'caption-medium-regular text-neutral-foreground-low',
  medium: 'caption-small-regular text-neutral-foreground-lowest',
  small: 'caption-xsmall-regular text-neutral-foreground-lowest'
};

const SUB_TITLE_SIZE = {
  large: 'pt-normal-large pb-tiny-large gap-tiny-medium',
  medium: 'pt-normal-large pb-tiny-large gap-tiny-medium',
  small: 'pt-normal-large pb-tiny-large gap-tiny-medium'
};

const titleVariants = cva('flex flex-col whitespace-nowrap', {
  variants: {
    size: { ...SUB_TITLE_SIZE }
  },
  defaultVariants: {
    size: 'medium'
  }
});

export interface SubTitleProps extends VariantProps<typeof titleVariants> {
  className?: string;
  title: ReactNode;
  description?: ReactNode;
  size?: keyof typeof SUB_TITLE_SIZE;
}

export const SubTitle = ({ className, size = 'medium', title, description, ...props }: SubTitleProps) => {
  return (
    <div className={titleVariants({ size, className })} {...props}>
      <div data-testid="subTitle" className={cn(SUB_TITLE_FONT[size], 'whitespace-pre-line break-words')}>
        {title}
      </div>
      {description && (
        <div data-testid="subTitleDescription" className={cn(DESCRIPTION_FONT[size], 'whitespace-pre-line break-words')}>
          {description}
        </div>
      )}
    </div>
  );
};
